import React from "react";
import { ArrowRight, PhoneCall } from "lucide-react";
import { Button } from "./ui/button";
import { companyInfo } from "../mock";

const CTA = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="relative rounded-3xl overflow-hidden bg-gradient-to-br from-brand-800 to-brand-950 p-10 md:p-14">
          <div className="absolute -top-24 -right-24 w-72 h-72 bg-accent2/20 rounded-full blur-3xl" />
          <div className="relative grid md:grid-cols-2 gap-8 items-center">
            <div>
              <h3 className="font-display text-[30px] md:text-[38px] leading-tight font-extrabold text-white">
                Bereit für eine Verwaltung, die wirklich verwaltet?
              </h3>
              <p className="mt-4 text-brand-200 max-w-md leading-relaxed">
                Vereinbaren Sie ein unverbindliches Erstgespräch. Wir hören zu, analysieren und
                zeigen Ihnen konkret, wie wir Ihre Immobilie voranbringen.
              </p>
            </div>
            <div className="flex flex-col sm:flex-row md:justify-end gap-3">
              <Button
                asChild
                className="bg-white text-brand-900 hover:bg-brand-50 rounded-full h-13 px-6 h-13"
              >
                <a href="#contact" className="inline-flex items-center gap-2">
                  Kontakt aufnehmen <ArrowRight className="w-4 h-4" />
                </a>
              </Button>
              <Button
                asChild
                variant="outline"
                className="rounded-full h-13 px-6 border-white/30 text-white hover:bg-white/10 hover:text-white"
              >
                <a
                  href={`tel:${companyInfo.phone.replace(/\s/g, "")}`}
                  className="inline-flex items-center gap-2"
                >
                  <PhoneCall className="w-4 h-4" /> {companyInfo.phone}
                </a>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;
